import Vue from 'vue'
import VueRouter from 'vue-router'
import UserHelper from '../../helpers/user'
import { setAuthToken } from '../../api/config'
import Game from '../views/Game.vue'
import Games from '../views/Games.vue'
import Users from '../views/Users.vue'
import User from '../views/User.vue'
import UserStats from '../views/UserStats.vue'
import UserReferal from '../views/UserReferal.vue'
import Referal from '../views/Referal.vue'
import Rights from '../views/Rights.vue'
import Payouts from '../views/Payouts.vue'
import GamesChats from '../views/GamesChats.vue'
import GameChat from '../views/GameChat.vue'
import Index from '../views/Index.vue'
import Promocodes from '../views/Promocodes.vue'
import PromocodesCreate from '../views/PromocodesCreate.vue'
import Login from '../components/authorization/Login'
import Multidomen from '@/views/Multidomen.vue'
import PaymentSystems from '@/views/PaymentSystems.vue'
import Lotteries from '../views/Lotteries.vue'
import Lottery from '@/views/Lottery.vue'
import AdminLogs from '../views/AdminLogs'
import UserAppeal from '../views/UserAppeal.vue'
import Transactions from '@/views/Transactions.vue'
import TrustPoints from '@/views/TrustPoints.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/auth',
    name: 'auth',
    component: Login,
    meta: { title: 'Авторизация' }
  },
  {
    path: '/games',
    name: 'games',
    component: Games,
    meta: { title: 'Игры' }
  },
  {
    path: '/games/:game',
    name: 'game',
    component: Game,
    meta: { title: 'Catcher' }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: { title: 'Пользователи' }
  },
  {
    path: '/users/:user',
    name: 'user',
    component: User,
    meta: { title: 'Пользователь ID:1551' }
  },
  {
    path: '/users/:user/appeal',
    name: 'user-appeal',
    component: UserAppeal,
    meta: { title: 'Апелляция пользователя' }
  },
  {
    path: '/users/:user/stats',
    name: 'user-stats',
    component: UserStats,
    meta: { title: 'Пользователь ID:1552' }
  },
  {
    path: '/users/:user/referal',
    name: 'user-referal',
    component: UserReferal,
    meta: { title: 'Пользователь ID:1552' }
  },
  {
    path: '/referal',
    name: 'referal',
    component: Referal,
    meta: { title: 'Реферальная программа' }
  },
  {
    path: '/rights',
    name: 'rights',
    component: Rights,
    meta: { title: 'Права доступа ' }
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: Transactions,
    meta: { title: 'Транзакции' }
  },
  {
    path: '/trust-points',
    name: 'trust-points',
    component: TrustPoints,
    meta: { title: 'Trust Points' }
  },
  {
    path: '/payouts',
    name: 'payouts',
    component: Payouts,
    meta: { title: 'Выплаты' }
  },
  {
    path: '/games-chats',
    name: 'games-chats',
    component: GamesChats,
    meta: { title: 'Чат' }
  },
  {
    path: '/game-chat',
    name: 'game-chat',
    component: GameChat,
    meta: { title: 'Чат' }
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: { title: 'Баннеры' }
  },
  {
    path: '/promocodes',
    name: 'promocodes',
    component: Promocodes,
    meta: { title: 'Промокоды' }
  },
  {
    path: '/promocodes/create',
    name: 'promocodes-create',
    component: PromocodesCreate,
    meta: { title: 'Создание нового промокода' }
  },
  {
    path: '/lotteries',
    name: 'lotteries',
    component: Lotteries,
    meta: { title: 'Lotteries' }
  },
  {
    path: '/lotteries/:lottery',
    name: 'lottery',
    component: Lottery,
    meta: { title: 'Розыгрыш №:1551' }
  },
  {
    path: '/multidomen',
    name: 'multidomen',
    component: Multidomen,
    meta: { title: 'Мультидомены' }
  },
  {
    path: '/payment-system',
    name: 'payment-system',
    component: PaymentSystems,
    meta: { title: 'Платежные системы' }
  },
  {
    path: '/logs',
    name: 'logs',
    component: AdminLogs,
    meta: { title: 'Логи пользователя' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if ((UserHelper.isAuth() && UserHelper.hasAccess()) || to.path.indexOf('/auth') + 1) {
    setAuthToken(UserHelper.getToken())
    if (UserHelper.isAuth() && UserHelper.hasAccess())
      if (to.path.indexOf('/auth') + 1)
        next({ path: '/games' })
      else if (to.path.includes('/logs') && !UserHelper.hasAdminAccess())
        next({ path: '/games' })
      else if (to.path.includes('/rights') && !UserHelper.isSuperAdmin())
        next({ path: '/games' })
      else
        next()

    else
      next()

  } else {
    next({ path: '/auth' })
  }
})

export default router
